module.exports = __webpack_public_path__ + "img/love-red.bda5d624.jpg";